import React, { useState } from "react";
import _uniqueId from "lodash/uniqueId";
import Select from "react-select";

export default function FieldSelect({
  label,
  options = [],
  multiple = false,
  placeholder,
  information,
  value,
  style,
  onChange,
  required = false,
  readonly = false,
  classNames = "",
  inputClassName = "",
  error,
  id,
  customStyles,
  loadOptions = null,
  components = null,
  setFormControlSelect = true,
}) {
  const [uniqueId] = useState(_uniqueId("field_"));

  return (
    <div className={"form-group " + classNames} style={style}>
      {label && <label htmlFor={id}>{label}</label>}
      <Select
        name={`${id || uniqueId}`}
        className={`${setFormControlSelect ? `form-control-select` : null} ${inputClassName}`}
        styles={customStyles}
        isSearchable={true}
        required={required}
        isDisabled={readonly}
        onChange={onChange}
        value={value}
        isMulti={multiple}
        id={`${id || uniqueId}`}
        options={options}
        placeholder={placeholder}
        onInputChange={loadOptions}
        components={components}
      />
      {information ? (
        <small id={uniqueId + "Help"} className="form-text text-muted">
          {information}
        </small>
      ) : null}
      {error ? (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
